/**
 * ColorTokens pulled from
 * https://www.figma.com/file/D2uWFGX4XBbzDlYYlxKnzs/Karius-Design-Language?node-id=1366%3A114
 * Theme palette should extend ColorTokens
 * NOTE: Two tokens are not here, 'background' and 'error'
 * These are built into the MUI theme and are access via 'background.primary' and 'error.primary'
 */
import { colorPalette } from './colorPalette';
export const colorTokens = {
    text_01: colorPalette.Blue800,
    icon_01: colorPalette.Blue800,
    inverse_background: colorPalette.Blue800,
    interactive: colorPalette.Teal500,
    text_link: colorPalette.Teal500,
    inverse_interactive: colorPalette.Teal300,
    text_error: colorPalette.Orange500,
    ui_01_hover: colorPalette.Grey50,
    ui_01_active: colorPalette.Teal500Light,
    interactive_hover: colorPalette.Teal600,
    text_link_hover: colorPalette.Teal600,
    error_hover: colorPalette.Orange600,
    text_05: colorPalette.White,
    ui_01: colorPalette.White,
    inverse_icon: colorPalette.White,
    inverse_text: colorPalette.White,
    ui_05: colorPalette.Grey50,
    ui_03: colorPalette.Grey100,
    interactive_disabled: colorPalette.Grey100,
    ui_04: colorPalette.Grey300,
    text_04: colorPalette.Grey300,
    icon_04: colorPalette.Grey300,
    text_03: colorPalette.Grey500,
    icon_03: colorPalette.Grey500,
    text_02: colorPalette.Grey600,
    ui_02: colorPalette.Grey600,
    icon_02: colorPalette.Grey600,
    support_error: colorPalette.Orange600,
    support_error_background: colorPalette.Orange50,
    support_error_border: colorPalette.Orange200,
    support_success: colorPalette.Mint600,
    support_success_background: colorPalette.Mint50,
    support_success_border: colorPalette.Mint200,
    support_information: colorPalette.Blue600,
    support_information_background: colorPalette.Blue50,
    support_information_border: colorPalette.Blue200,
    support_warning: colorPalette.Yellow600,
    support_warning_background: colorPalette.Yellow50,
    support_warning_border: colorPalette.Yellow200,
    text_06: colorPalette.Grey100,
    icon_06: colorPalette.Grey100,
    icon_05: colorPalette.White,
};
